import type { ComponentProps } from 'react'
import { Toaster as Sonner } from 'sonner'
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react'
import 'sonner/dist/styles.css'

type AppToasterProps = ComponentProps<typeof Sonner>

export function AppToaster(props: AppToasterProps) {
  return (
    <Sonner
      theme="light"
      className="app-toaster pointer-events-auto z-[100000]"
      position="top-right"
      expand
      richColors
      closeButton
      visibleToasts={4}
      gap={12}
      offset={16}
      duration={4000}
      icons={{
        success: <CheckCircle className="h-4 w-4 shrink-0" strokeWidth={2} />,
        error: <XCircle className="h-4 w-4 shrink-0" strokeWidth={2} />,
        warning: <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={2} />,
        info: <Info className="h-4 w-4 shrink-0" strokeWidth={2} />,
      }}
      toastOptions={{
        classNames: {
          toast: 'app-toast',
          title: 'app-toast-title',
          description: 'app-toast-description',
          actionButton: 'app-toast-action',
          cancelButton: 'app-toast-cancel',
          closeButton: 'app-toast-close',
        },
      }}
      {...props}
    />
  )
}

export default AppToaster
